exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".how-to-donate header{margin-bottom:30px}.how-to-donate section{padding:40px 0}.how-to-donate .circle-counter{border-radius:50%;width:60px;height:60px;background-color:#b6102f;display:flex;justify-content:center;align-items:center;margin:0 auto;margin-bottom:30px}.how-to-donate .circle-counter span{font-size:30px;font-weight:700;color:#fff}.how-to-donate ul{font-size:15pt;font-weight:300;margin:30px 0}.how-to-donate ul li{margin:10px 0}.how-to-donate .section-content .subsection{margin-bottom:30px}.how-to-donate .section-content .subsection:last-child{margin-bottom:0}.how-to-donate .section-content h3{margin-top:20px;margin-bottom:20px}.how-to-donate .section-content h3:first-child{margin-top:0}.how-to-donate .bank-account-data{margin-top:30px;border-radius:4px;background-color:#ddd;padding:20px}.how-to-donate img{display:block;margin-top:20px;margin-left:auto;margin-right:auto;margin-bottom:5px}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/Containers/Pages/HowToDonatePage.scss
// module id = 1078
// module chunks = 0